<template>
  <div>
    <ion-button
      id="trigger-button"
      class="welcome-btn"
      ion-button
      expand="block"
      color="primary"
      >Sign up with Email</ion-button
    >
    <ion-modal
      :is-open="modalIsOpen"
      :breakpoints="[0.1, 0.45, 0.5, 1]"
      :initialBreakpoint="0.35"
      trigger="trigger-button"
    >
      <ion-content>
        <div align="center" class="si-modal">
          <span class="welcome-span">Create a new account</span>
          <a href="/usersignup">
            <ion-button class="welcome-btn" expand="block" color="primary">
              Sign up with Email
            </ion-button>
          </a>
          <div v-if="isMobileWeb">
            <span class="welcome-or">or</span>
            <ion-button
              class="continue-google-btn"
              expand="block"
              fill="outline"
              @click="connectWithGoogleOnWeb"
            >
              <ion-icon src="assets/icon/icon-google.svg"></ion-icon>
              Continue with Google
            </ion-button>
            <ion-button
              class="continue-fb-btn"
              expand="block"
              color="tertiary"
              @click="connectWithFacebookOnWeb"
            >
              <ion-icon src="assets/icon/icon-facebook.svg"></ion-icon>
              Continue with Facebook
            </ion-button>
          </div>
          <div v-if="isAndroid">
            <span class="welcome-or">or</span>
            <ion-button
              class="continue-google-btn"
              expand="block"
              fill="outline"
              @click="connectWithGoogleOnAndroid"
            >
              <ion-icon src="assets/icon/icon-google.svg"></ion-icon>
              Continue with Google
            </ion-button>
          </div>
          <!--<ion-button
            class="continue-fb-btn"
            expand="block"
            color="tertiary"
            @click="connectWithFacebook"
          >
            <ion-icon src="assets/icon/icon-facebook.svg"></ion-icon>
            Continue with Facebook
          </ion-button>-->
        </div>
      </ion-content>
    </ion-modal>
  </div>
</template>
<script>
import {
  IonModal,
  IonButton,
  IonContent,
  IonIcon,
  alertController,
  isPlatform,
  getPlatforms,
} from "@ionic/vue";
import { defineComponent, ref } from "vue";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import axios from "axios";
import { modalController } from "@ionic/vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

const BASE_URI_HTTPS =
  process.env.VUE_APP_BASE_URI_HTTPS !== undefined
    ? process.env.VUE_APP_BASE_URI_HTTPS
    : BASE_URI;

export default defineComponent({
  name: "SignInModal",
  components: { IonModal, IonButton, IonContent, IonIcon },
  data() {
    return {
      devicePlatform: [],
      isMobileWeb: false,
      isAndroid: false,
      isIOS: false,
    };
  },
  setup() {
    const modalIsOpen = ref(false);

    const closeModal = () => {
      modalController.dismiss(); // Use Ionic modalController to dismiss the modal
    };

    return {
      modalIsOpen,
      closeModal,
    };
  },
  methods: {
    async presentAlert() {
      const alert = await alertController.create({
        message: this.promptMessage,
      });

      await alert.present();
      await alert.onDidDismiss();
    },
    async connectWithGoogleOnWeb() {
      localStorage.setItem("provider", "google");
      window.location.href = BASE_URI + "/auth/google";
    },
    async connectWithFacebookOnWeb() {
      localStorage.setItem("provider", "facebook");
      window.location.href = BASE_URI_HTTPS + "/auth/facebook";
    },
    async connectWithGoogleOnAndroid() {
      await modalController.dismiss();
      const result = await GoogleAuth.signIn();

      let loginData = {
        providerUserId: result.id,
        provider: "google",
        email: result.email,
        name: result.displayName,
      };

      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      this.isFetching = true;
      await axios
        .post(BASE_URI + "/auth/google/validate", loginData, axiosConfig)
        .then((res) => {
          if (res.data.status === 200) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("id", res.data.data.id);
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("email", res.data.data.email);
            localStorage.setItem("mobile", res.data.data.mobile);
            localStorage.setItem("provider", res.data.data.provider);
            localStorage.setItem("isVerified", res.data.data.isVerified);
            localStorage.setItem("userType", res.data.data.userType);
            localStorage.setItem("cafeId", res.data.data.cafeId);

            if (res.data.data.isVerified == true) {
              if (res.data.data.userType == "customer")
                this.$router.replace("/home");
              else this.$router.replace("/admin");
            } else {
              this.$router.push("/complete-profile");
            }

            this.isFetching = false;
          }

          if (res.data.status === 201) {
            this.isFetching = false;
            this.$router.push(res.data.redirectURI);
          }
        })
        .catch((err) => {
          this.isFetching = false;
          this.promptMessage =
            err && err.response && err.response.data
              ? err.response.data.message
              : "";
          this.presentAlert();
          this.$router.push(err.response.data.redirectURI);
          return err;
        });
    },
  },
  async created() {
    // check device platform
    this.devicePlatform = getPlatforms();
    this.isMobileWeb =
      this.devicePlatform.includes("android") ||
      this.devicePlatform.includes("ios")
        ? false
        : isPlatform("mobileweb");
    this.isAndroid = isPlatform("android");
    this.isIOS = isPlatform("ios");

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get("err") === "409") {
      this.promptMessage = "Problem encountered while accessing this account.";
      this.presentAlert();
    }
  },
});
</script>
<style scoped>
.si-modal {
  margin-top: 30px;
}
.welcome-span {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  text-align: center;
  color: #828282;
  margin-top: 10%;
}
.welcome-or {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  text-align: center;
  color: #828282;
  margin-top: 10%;
}
.welcome-btn {
  font-weight: 600;
  font-size: 16px;
  font-family: "Gilroy";
  line-height: 19px;
  text-align: center;
  padding-left: 7%;
  padding-right: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  --border-radius: 4px;
  text-transform: none;
  letter-spacing: 1px;
  height: 45px;
}
.continue-google-btn {
  --border-color: #e1e1e1;
  --border-radius: 4px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #1b1b1b;
  padding-left: 7%;
  padding-right: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  text-transform: none;
  letter-spacing: 1px;
  height: 45px;
}
.continue-fb-btn {
  --border-radius: 4px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  padding-left: 7%;
  padding-right: 7%;
  margin-bottom: 5%;
  text-transform: none;
  letter-spacing: 1px;
  height: 45px;
}
ion-icon {
  font-size: 20px;
  padding-right: 10px;
}
</style>
